export default __webpack_public_path__ + "static/media/qrcodeGen.0ad085f9.png";